module.exports = __webpack_public_path__ + "static/media/Ecossistema-prontlife.fb3feec1.svg";